import { IsArray, IsEnum, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Expose, Type } from 'class-transformer';
import { AddressCreate, PackageCreate } from '.';
import { Currency, PurposeType, LogisticServiceCode, IncotermType } from '../common/enums';
import { ParserError } from '../common/errors';

export class PurchaseOrderCreate {
  constructor(props: Partial<PurchaseOrderCreate>) {
    Object.assign(this, props);
  }

  @Expose({ name: 'orderId' })
  @IsString()
  @Type(() => String)
  orderNumber!: string;

  @Expose({ name: 'type' })
  @IsEnum(PurposeType)
  shipmentPurpose!: PurposeType;

  @Expose({ name: 'logisticServiceCode' })
  @IsOptional()
  @IsEnum(LogisticServiceCode)
  carrierService?: LogisticServiceCode;

  @Expose()
  @IsEnum(Currency)
  currency!: Currency;

  @Expose()
  @IsOptional()
  @IsString()
  @Type(() => String)
  taxId?: string;

  @Expose()
  @IsArray()
  @IsOptional()
  @Type(() => PackageCreate)
  @ValidateNested()
  packages?: PackageCreate[] = [];

  @Expose({ name: 'receiverAddress' })
  @IsOptional()
  @Type(() => AddressCreate)
  @ValidateNested()
  receiver?: AddressCreate;

  @Expose({ name: 'shipperAddress' })
  @Type(() => AddressCreate)
  @ValidateNested()
  shipper!: AddressCreate;

  @Expose()
  @IsEnum(IncotermType)
  incoterm!: IncotermType;

  @Expose()
  createdAt?: Date;

  errors?: ParserError[] = [];
}
